import { teamLogoUrl, TEAMS_BY_ABBR } from '../constants/teams';

interface Props {
  abbr: string;
  size?: number;
  className?: string;
  title?: string;
}

export function TeamLogo({ abbr, size = 40, className = '', title }: Props) {
  const meta = TEAMS_BY_ABBR[abbr];
  if (!meta) return <div className={className} style={{ width: size, height: size }} />;
  return (
    <img
      src={teamLogoUrl(abbr)}
      alt={meta.name}
      title={title ?? `${meta.city} ${meta.name}`}
      width={size}
      height={size}
      className={`object-contain ${className}`}
      loading="lazy"
      onError={e => { (e.target as HTMLImageElement).style.opacity = '0.3'; }}
    />
  );
}
